import { createRouter, createWebHistory } from 'vue-router';
import { useCookies } from 'vue3-cookies';
import { firstWordCapitalize } from '@/utils/util';

const { cookies } = useCookies();
const modules = import.meta.glob('@/pages/**/*.vue');
const MAIN_PAGE = '/avatar';

export const routes: any[] = [];

function parsePath(path: any) {
  const parts: any = /^(.*[\\/])?(.*?)(\.[^.]*?|)$/gi.exec(path);
  const secondPathList = parts[0]?.replace('/src/pages/', '')?.split('/');
  secondPathList.pop();

  // 支持二级目录, 目前只支持二级
  if (secondPathList?.length) {
    if (parts[2] === 'index') {
      parts[2] = secondPathList[0];
    } else {
      parts[2] = `${secondPathList[0]}/${parts[2]}`;
    }
  }

  return {
    path: parts[0] || '',
    subpath: parts[1] || '',
    name: parts[2] || '',
    extension: parts[3] || '',
  };
}

function toKebabCase(str: string) {
  // make sure first character is lowercase
  str = str.charAt(0).toLowerCase() + str.slice(1);

  const result = str.replace(
    /[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g,
    (match) => '-' + match.toLowerCase()
  );
  return str[0] === str[0].toUpperCase() ? result.substring(1) : result;
}

function modifyDocumentTitle(name: any) {
  if (!name) return;
  // @ts-ignore
  const title = name?.replace('/', ' - ');
  document.title = title
    ? `${firstWordCapitalize(
        title
      )} | VisionStory - AI Video Generator, AI Character`
    : 'VisionStory - AI Video Generator, AI Character';
}

// 自动注入路由

Object.keys(modules).forEach((key) => {
  let auth = false;

  const parts = parsePath(key);
  let path = `/${toKebabCase(parts.name)}`;

  // 支持分享
  if (path.includes('/share')) {
    path = `${path}/:id`;
  }

  // 需要权限登录
  switch (parts.name) {
    case 'task':
      auth = true;
      break;
  }

  routes.push({
    path,
    name: parts.name,
    component: modules[parts.path],
    meta: {
      auth,
    },
  });
});

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const token = cookies.get('jwt_token') as string;
  const { name } = to;

  // 修改标题
  modifyDocumentTitle(name);

  //找不到的主页面
  if (!to.matched.length) {
    next({
      name: 'avatar',
    });
  }

  if (
    // 登录成功，直接跳转到首页
    to.matched.some(
      (record) =>
        record.name === 'login' ||
        record.name === 'signup' ||
        record.name === 'authorizing' ||
        (record.name === 'svgs' && location.host === 'www.visionstory.ai')
    ) &&
    token
  ) {
    // 判断该路由是否需要登录权限
    next({
      path: MAIN_PAGE,
    });
  }

  if (to.matched.some((record) => record.meta.auth) && to.meta.auth) {
    // 判断该路由是否需要登录权限

    if (token) {
      // 获取当前的 token 是否存在
      next();
    } else {
      next({
        path: MAIN_PAGE,
      });
    }
  }
  next();
});

export default router;
